module.exports = __webpack_public_path__ + "static/media/bannerBg.59cbdf56.jpg";